import React from "react";

export const AppDetailsHeaderSkeleton: React.FC = () => {
  return (
    <div className="flex items-center gap-2">
      <div className="w-10 h-10 rounded-lg bg-gray-200 dark:bg-neutral-700 animate-pulse" />
      <div className="space-y-2">
        <div className="h-5 w-48 bg-gray-200 dark:bg-neutral-700 rounded animate-pulse" />
        <div className="flex items-center gap-2">
          <div className="h-4 w-24 bg-gray-200 dark:bg-neutral-700 rounded animate-pulse" />
          <div className="h-4 w-16 bg-gray-200 dark:bg-neutral-700 rounded animate-pulse" />
        </div>
      </div>
    </div>
  );
};

export default AppDetailsHeaderSkeleton;
